<template>
  <div>
    <a-row>
      <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 24 }">
        <!-- <a-card v-if="showresult"> Please select a gene! </a-card> -->
        <a-card size="large" style="width: 99%">
          <!-- <a slot="extra" href="#"><a-icon type="download"></a-icon></a> -->
          <span slot="title">
            There are top {{ this.getdata_detable.length }} records of
            Connectivity Score were founded.
          </span>
          <a-spin :spinning="spinning" tip="Loading...">
            <vxe-toolbar>
              <template #buttons>
                <!-- <vxe-input
              v-model="filterName_detable"
              type="search"
              placeholder="Input gene"
            ></vxe-input> -->
                <vxe-button @click="exportDataEvent"
                  ><a-icon type="cloud-download" /> TSV</vxe-button
                >
              </template>
            </vxe-toolbar>
            <vxe-table
              border
              show-overflow
              :row-config="{ height: 30 }"
              row-id="id"
              size="small"
              ref="xTable"
              :data="tableData_detable"
              :expand-config="{ lazy: true, loadMethod: loadContentMethod }"
            >
              <!-- 内部展开药物实验详细信息 -->
              <vxe-column
                type="expand"
                width="40"
                :titlePrefix="{
                  icon: 'vxe-icon-question-circle-fill',
                  useHTML: true,
                  message: 'Click to show cell details',
                }"
              >
                <template #content="{ row }">
                  <div class="expand-wrapper" style="margin: 10px 100px">
                    <vxe-grid
                      :columns="row.childCols"
                      :data="row.childData"
                    ></vxe-grid>
                  </div>
                </template>
              </vxe-column>
              <!-- 内部展开药物实验详细信息 -->
              <vxe-column
                field="genename"
                title="Gene Symbol"
                width="140px"
                type="html"
              >
              </vxe-column>
              <vxe-column
                field="PCLs"
                title="PCLs"
                :titlePrefix="{
                  icon: 'vxe-icon-question-circle-fill',
                  useHTML: true,
                  message:
                    'A Perturbagen CLass (PCL) refers to a CMap-designated grouping of compounds or genetic perturbagens. ',
                }"
                type="html"
              ></vxe-column>
              <vxe-column
                field="avgScore"
                title="avgScore"
                width="180px"
                sortable
                :titlePrefix="{
                  icon: 'vxe-icon-question-circle-fill',
                  useHTML: true,
                  message:
                    'Since there are multiple cell data predicting outcome scores, we took an average score',
                }"
                type="html"
              ></vxe-column>
              <vxe-column
                field="cellnum"
                title="Number of cell types"
                sortable
                type="html"
                width="180px"
              ></vxe-column>
              <vxe-column
                field="datasets"
                title="Datasets"
                width="180px"
                type="html"
              ></vxe-column>
              <template #empty>
                <span style="color: grey"> No records! </span>
              </template>
            </vxe-table>

            <vxe-pager
              background
              size="small"
              :loading="loading_detable"
              :current-page="tablePage_detable.currentPage"
              :page-size="tablePage_detable.pageSize"
              :total="tablePage_detable.totalResult"
              :page-sizes="[10]"
              :layouts="[
                'PrevPage',
                'JumpNumber',
                'NextPage',
                // 'FullJump',
                // 'Sizes',
                // 'Total',
              ]"
              @page-change="handlePageChange_table"
            >
            </vxe-pager>
          </a-spin>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import axios from "axios";
// import XEUtils from "xe-utils";
// import downloadexcel from "vue-json-excel";

export default {
  props: ["dataset"],
  data() {
    return {
      //druglist
      druglist: false,
      datasetlist: [],
      //drug list done
      showresult: true,
      //加载
      spinning: true,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },

  watch: {
    //如果换了dataset 就晴空数据, 要选到基因才能展示结果
    selectDataset() {
      this.showresult = true;
      this.getdata_detable = null;
      this.tableData_detable = null;
    },
    selectGene() {
      this.showresult = false;
    },
    dataset() {
      axios
        .get("http://www.perturbdb.com/API/drug/geneTarget_geneModelCPs.php", {
          params: {
            genename: this.$route.query.selectItem,
            dataset: this.dataset,
          },
        })
        .then((response) => {
          this.getdata_detable = response.data;
          this.tableData_detable = response.data;
          //console.log(response.data);
          this.findList_detable(this.getdata_detable);
          this.spinning = false;
        });
    },
  },
  created() {},

  methods: {
    showDrug() {
      // alert("dianjiwole");
      this.druglist = true;
    },
    loadContentMethod({ row }) {
      return new Promise((resolve) => {
        setTimeout(() => {
          let childCols = [
            { type: "html", title: "Cell name", field: "cell" },
            { type: "html", title: "Score", field: "score" },
          ];
          // 这个地方只要把一个row的字段传进来就好了
          row.childCols = childCols;
          row.childData = row.subTable;
          resolve();
        }, 200);
      });
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename:
            this.$route.query.selectItem + "_targetedDrug_CPs_" + this.dataset,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename: this.filterName_detable + "_related",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    // searchEvent_detable() {
    //   const filterName = XEUtils.toValueString(this.filterName_detable)
    //     .trim()
    //     .toLowerCase();
    //   if (filterName) {
    //     const filterRE = new RegExp(filterName, "gi");
    //     const searchProps = ["diffgene", "perturbgene"];
    //     const rest = this.getdata_detable.filter((item) =>
    //       searchProps.some(
    //         (key) =>
    //           XEUtils.toValueString(item[key])
    //             .toLowerCase()
    //             .indexOf(filterName) > -1
    //       )
    //     );
    //     this.tempdata_detable = rest.map((row) => {
    //       const item = Object.assign({}, row);
    //       searchProps.forEach((key) => {
    //         item[key] = XEUtils.toValueString(item[key]).replace(
    //           filterRE,
    //           (match) => `${match}`
    //         );
    //       });
    //       return item;
    //     });
    //     this.findList_detable(this.tempdata_detable);
    //   } else {
    //     this.findList_detable(this.getdata_detable);
    //   }
    // },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
</style>
